export const addRowNumber = (rows: any[], page: number, limit: number) => {
  return rows.map((row, index) => {
    return { ...row, rowNumber: (page - 1) * limit + index + 1 };
  });
};
